import React from "react";

function PersonalizedSvg({ color = "#000000", width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 512 512"
      fill={color}
    >
      <g>
        <path
          d="M30.154 146.154h55.763c-3.571-9.378-5.543-19.538-5.543-30.154s1.973-20.775 5.543-30.154H30.154C13.5 85.846 0 99.346 0 116s13.5 30.154 30.154 30.154zM481.846 146.154C498.5 146.154 512 132.654 512 116s-13.5-30.154-30.154-30.154h-236.98c3.571 9.378 5.544 19.538 5.544 30.154s-1.973 20.775-5.544 30.154z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
        <circle
          cx="165.392"
          cy="116"
          r="55.019"
          fill={color}
          opacity="1"
          data-original={color}
        ></circle>
        <path
          d="M481.846 225.846h-76.98c3.571 9.378 5.544 19.538 5.544 30.154s-1.973 20.775-5.544 30.154h76.98C498.5 286.154 512 272.654 512 256s-13.5-30.154-30.154-30.154zM30.154 286.154h215.763c-3.571-9.378-5.543-19.538-5.543-30.154s1.973-20.775 5.543-30.154H30.154C13.5 225.846 0 239.346 0 256s13.5 30.154 30.154 30.154z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
        <circle
          cx="325.392"
          cy="256"
          r="55.019"
          fill={color}
          opacity="1"
          data-original={color}
        ></circle>
        <path
          d="M481.846 365.846h-176.98c3.571 9.378 5.544 19.538 5.544 30.154s-1.973 20.775-5.544 30.154h176.98C498.5 426.154 512 412.654 512 396s-13.5-30.154-30.154-30.154zM30.154 365.846C13.5 365.846 0 379.346 0 396s13.5 30.154 30.154 30.154h115.763c-3.571-9.378-5.543-19.538-5.543-30.154s1.973-20.775 5.543-30.154z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
        <circle
          cx="225.392"
          cy="396"
          r="55.019"
          fill={color}
          opacity="1"
          data-original={color}
        ></circle>
      </g>
    </svg>
  );
}

export default PersonalizedSvg;
